import { FC, PropsWithChildren } from 'react';
import { CatSearchForm } from '@blocks-react/components/SearchForm';
import { MyEquipmentSearchProps } from '../types';

export const MyEquipmentSearch: FC<
  PropsWithChildren<MyEquipmentSearchProps>
> = ({
  placeholder,
  onSearch,
  dataCsMask,
  size = 'md',
  ...searchFormProps
}) => {
  return (
    <CatSearchForm
      mobileBreakPoint={0} // prevent search modal from opening when in mobile view
      size={size}
      placeholder={placeholder}
      isEmpty
      data-testid="myEquipmentSearch"
      onBlChange={(e) => {
        onSearch && onSearch(e.detail.value ?? '');
      }}
      data-cs-mask={dataCsMask}
      {...searchFormProps}
    />
  );
};
